<template>
   <div class="layout-page">
      <h1>Profile Page</h1>

      <p><em>Complete the signup process by entering the following information:</em></p>

      <p class="font-smaller ml-corp"><em>* NOTE *</em> - You can change your password <a href="">here</a>.</p>

      <form class="needs-validation" novalidate>
         <div class="form-group">
            <label for="email">Email/Username:</label>
            <input
               type="text"
               class="form-control"
               id="email"
               name="email"
               readonly
               v-model="emailAddress"
               data-fieldname="Email Address"
            />
            <input type="hidden" v-model="externalUserId" />
         </div>
         <div class="form-group">
            <label for="firstName">First Name:</label>
            <input
               type="text"
               class="form-control"
               id="firstName"
               name="firstName"
               v-model="firstName"
               required
               data-fieldname="First Name"
            />
         </div>
         <div class="form-group">
            <label for="middleName">Middle Name: <span class="cap">(or Initial)</span></label>
            <input
               type="text"
               class="form-control"
               id="middleName"
               name="middleName"
               v-model="middleName"
               required
               data-fieldname="Middle Name"
            />
         </div>
         <div class="form-group">
            <label for="lastName">Last Name:</label>
            <input
               type="text"
               class="form-control"
               id="lastName"
               name="lastName"
               v-model="lastName"
               required
               data-fieldname="Last Name"
            />
         </div>
         <div class="form-group">
            <label for="phoneNumber">Phone Number: <span class="cap">(###-###-#### 10 digits)</span></label>
            <input
               type="text"
               class="form-control"
               id="phoneNumber"
               name="phoneNumber"
               v-model="phoneNumber"
               v-on:input="checkPhone"
               required
               data-fieldname="Phone Number"
            />
         </div>
         <button
            type="button"
            class="btn ml-btn ml-bk-black ml-h-corp ml-white mart-12 marb-12"
            @click.prevent="$router.push({ name: 'home' })"
         >
            <i class="fi-interface-previous"></i>
            CANCEL
         </button>
         &nbsp; &nbsp;
         <button
            type="button"
            class="btn ml-btn ml-bk-corp ml-white mart-12 marb-12"
            @click.prevent="handleSave"
         >
            <i class="fas fa-spinner fa-spin" v-if="saving"></i>
            <span v-else>
               <i class="fi-interface-save"></i>
               SAVE
            </span>
         </button>
      </form>
   </div>
</template>

<script>
export default {
   name: "Protected",
   data() {
      return {
         emailAddress: this.$store.getters.userEmail,
         externalUserId: this.$store.getters.userClaims.oid,
         firstName: this.$store.getters.userClaims.given_name,
         lastName: this.$store.getters.userClaims.family_name,
         middleName: this.$store.getters.userClaims.extension_MiddleName,
         phoneNumber: this.$store.getters.userClaims.extension_PhoneNumber,
         //taxId: this.$store.getters.userClaims.extension_TaxID,

         saving: false
      };
   },
   mounted() {
      window.addEventListener(
         "load",
         function () {
            // Get the forms we want to add validation styles to
            var forms = document.getElementsByClassName("needs-validation");
            // Loop over them and prevent submission
            var validation = Array.prototype.filter.call(forms, function (form) {
               form.addEventListener(
                  "submit",
                  function (event) {
                     if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                     }
                     form.classList.add("was-validated");
                  },
                  false
               );
            });
         },
         false
      );
   },
   methods: {
      checkPhone() {
         let theForm = document.forms[0];
         let ph = this.phoneNumber.replace(/-/g, "").replace(/ /g, "");
         if (this.phoneNumber != "" && ph.length != 10) {
            theForm.phoneNumber.setCustomValidity("Phone Number is invalid");
         } else {
            theForm.phoneNumber.setCustomValidity("");
         }
      },
      //checkSSN() {
      //   let theForm = document.forms[0];
      //   let s = this.taxId.replace(/-/g, "").replace(/ /g, "");
      //   if (this.taxId != "" && s.length != 9) {
      //      theForm.taxId.setCustomValidity("Social Security NumberTax ID is invalid");
      //   } else {
      //      theForm.taxId.setCustomValidity("");
      //   }
      //},
      async handleSave() {
         let theForm = document.forms[0];
         const isValid = theForm.checkValidity();
         theForm.classList.add("was-validated");
         if (!isValid) {
            let validMsg = this.findBadFields(theForm);
            this.$swal(
               "Missing or Invalid",
               "Some fields in the form are <b>missing</b> or <b>invalid</b>:<br />" +
                  validMsg +
                  ".<br /><br />Please make corrections and then click Next again.",
               "error"
            )
            this.busy = false;
            return;
         }

         this.saving = true

         var payload = {
            FirstName: this.firstName,
            MiddleName: this.middleName,
            LastName: this.lastName,
            PhoneNumber: this.phoneNumber,
         //   TaxId: this.taxId
         }
         await this.$user.updateProfile(payload)
         .then(resp => {
            this.saving = false
            this.$swal(
               "Successfully Updated!",
               "Your profile information has been successfully updated.",
               "success"
            ).then( r => {
               let usr = this.$store.getters.userClaims
               usr.given_name = this.firstName
               usr.family_name = this.lastName
               usr.extension_MiddleName = this.middleName
               usr.extension_PhoneNumber = this.phoneNumber
               //usr.extension_TaxID = this.taxId
               this.$store.commit('updateUserClaims', usr)              
               this.$router.push({ name:'home' }).catch(e =>{})
            })
         })
         .catch(err => {
            this.saving = false

            this.$swal(
               "Profile Update Failed",
               "Updating your profile failed at this time. We apologize for the inconvenience. Please try again later. If this problem persists please contact support.",
               "error"
            );
         })
      },
      findBadFields: function (frm) {
         // Harvest the names of the bad fields
         let result = "";
         for (let f = 0; f < frm.elements.length; f++) {
            const field = frm.elements[f]
            if (
               field.nodeName !== "INPUT" &&
               field.nodeName !== "TEXTAREA" &&
               field.nodeName !== "SELECT"
            )
               continue;
            if (!field.validity.valid) {
               result += field.getAttribute("data-fieldname") + ", ";
            }
         }
         // Chop off the trailing comma if neccessary
         if (result.length > 2) {
            result = result.substr(0, result.length - 2);
         }
         return result;
      },
   },
};
</script>

<style lang="scss" scoped>
button {
   width: 100px;
}
.cap {
   font-size: .6em;
   color: #ccc;
}
</style>